var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.774.048C.794.048 0 .815 0 1.76v20.48c0 .946.795 1.712 1.774 1.712h20.452c.98 0 1.774-.767 1.774-1.712V1.76c0-.945-.794-1.712-1.774-1.712zm5.52 9.243v10.761H3.701V9.291zm.236-3.328c0 1.032-.78 1.859-2.032 1.859h-.023c-1.206 0-1.985-.827-1.985-1.86 0-1.056.803-1.859 2.032-1.859 1.228 0 1.985.803 2.008 1.86m5.342 14.09h-3.59s.046-9.752 0-10.762h3.59v1.523c.478-.733 1.332-1.776 3.237-1.776 2.363 0 4.134 1.539 4.134 4.844v6.17h-3.59v-5.756c0-1.447-.52-2.434-1.82-2.434-.992 0-1.583.666-1.842 1.309-.095.229-.119.551-.119.872z",
  clipRule: "evenodd"
})));
export default SvgLinkedin;